import { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from "@mui/material";

export interface ReverseSequenceDialogProps
  extends Omit<
    DialogProps,
    "onClose" | "open" | "style" | "inputValue" | "handler"
  > {
  onConfirm: (onClose: () => void, value?: string) => void;
  onClose: () => void;
  open?: boolean;
}

export const ReverseSequenceDialog: FC<ReverseSequenceDialogProps> = (
  props,
) => {
  const { sx, onConfirm, onClose, open, ...rest } = props;

  return (
    <Dialog onClose={onClose} {...rest} sx={sx || {}} open={open || false}>
      <DialogTitle>Reverse Sequence</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginY: "16px" }}>
          Are you sure you want to reverse sequence?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{ color: "#8ACEFF" }}
          data-testid="cancel-button"
        >
          Cancel
        </Button>
        <Button
          onClick={() => onConfirm(onClose, "confirm")}
          variant="contained"
          sx={{
            backgroundColor: "#8ACEFF",
            color: "#00344E",
          }}
          data-testid="confirm-button"
        >
          Reverse Sequence
        </Button>
      </DialogActions>
    </Dialog>
  );
};
